export const General_API = {
    liveSearch: {orgsSearch},
    passwordRestore: {passwordRestoreStep1, passwordRestoreStep2},
    notifications: { getAllNotifications, getNotificationById, accept, cancel, changeStatus }
}


function accept(userId,id) {
    return {api: `/api/v2/systemManagers/${userId}/notifications/${id}/accept`, method: 'POST'}
}
function cancel(userId,id) {
    return {api: `/api/v2/systemManagers/${userId}/notifications/${id}/cancel`, method: 'POST'}
}
function getAllNotifications(userId,limit, offset) {
    return {api: `/api/v2/systemManagers/${userId}/notifications?limit=${limit}&offset=${offset}`, method: 'GET'}
}
function getNotificationById(id, limit, offset, filters) {
    return { api: `/api/v2/patients/${id}/notifications?limit=${limit}&offset=${offset}&${filters? filters : ""}`, method: 'GET' }
}
function passwordRestoreStep1() {
    return {api: '/api/v2/general/password/reset', method: 'POST'}
}

function passwordRestoreStep2() {
    return { api: '/api/v2/general/password/confirm', method: 'POST' }
}

function changeStatus(id) {
    return { api: `/api/v1/systemManager/notifications/${id}/inprogress`, method: 'PUT' }
}

function orgsSearch(name, type) {

    const orgType = {
        verificationCenter: 'удостоверяющий',
        medcenter: 'медцентр',
        organization: 'организация',
        allOrganizations: 'организацияМедцентр'
    }


    return {api: `/api/v2/organizations/search?name=${encodeURIComponent(name)}&type=${orgType[type]}`, method: `GET`}
}